/**
 * Created by Abner Sui on 05/20/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Subject } from 'rxjs';

export class QueryInfo {
    searchText: string;
    sortBy: string;
    sortOrder: string;

    constructor() {
        this.searchText = '';
        this.sortBy = 'lastediteddate';
        this.sortOrder = 'desc';
    }
}

export class FileViewListConfig {
    actions$: Subject<any>;
    events$: Subject<any>;

    constructor(public prefix: string = null, public instanceId: string = null, public hideKeyword: boolean = false) {
        this.actions$ = new Subject();
        this.events$ = new Subject();
    }
}

export class SortInfo {
    sortBy: string;
    sortOrder: 'asc' | 'desc';

    constructor() {
        this.sortBy = 'lastediteddate';
        this.sortOrder = 'desc';
    }
}

export class FileViewInfo {
    sortInfo: SortInfo;
    refineByInfo: any;

    constructor() {
        this.sortInfo = new SortInfo();
    }
}

export enum FileViewConfigActionTypes {
    FILTER = 'FILTER'
}

export class FileViewConfigAction {
    constructor(
        public type: FileViewConfigActionTypes,
        public payload: any) { }
}

export enum FileViewConfigFeedbackTypes {
    VIEW_READY = 'VIEW_READY'
}

export class FileViewConfigFeedback {
    constructor(
        public type: FileViewConfigFeedbackTypes,
        public payload: any) { }
}

export class FileViewConfig {
    public actionSubject$: Subject<FileViewConfigAction>;
    public feedbackSubject$: Subject<FileViewConfigFeedback>;
    constructor(public actionKeyName: string, public instanceId: string, public hideKeyword: boolean = false, public keyword: string = '') {
        this.actionSubject$ = new Subject<FileViewConfigAction>();
        this.feedbackSubject$ = new Subject<FileViewConfigFeedback>();
    }
}
